export function isFatal(m) {
    return typeof m === "object" && m !== null && typeof m.fatal === "string";
}
//# sourceMappingURL=protocol.js.map